<div class="BRLtPanel" *ngIf="!(isSectionsEmpty$ | async)">
    <div class="hdLab">Modules</div>
    <div>
        <ul class="BRNavUl p-0 m-0">
            @for (section of sections(); track section; let i = $index) {
            <li class="BRNavLi"><a class="flex align-items-center justify-content-between"
                    [class.active]="activeSection() === section.id ? 'active': ''" (click)="onSectionClick(section)">
                    <div style="width: 165px;">{{ section?.reportName }}</div>
                    <div style="margin-right:10px">{{ section.savedReports.length }}</div>
                </a></li>
            }
            @if(selectedTab == 'reports-library') {
            <li class="BRNavLi"><a target="_blank" class="flex align-items-center justify-content-between" [href]="thDomain + 'Reports/GeneralReport'">General Reports</a></li>
            }
        </ul>
    </div>
</div>